import { Injectable } from '@angular/core';
import { Select } from 'ol/interaction';
import { GlobalSelectionControlService } from '../map/services/global-selection-control.service';

import { ParentLayers } from '../menu/view-menu/parent-layer';
import { SearchItem } from '../models/searchItem';
import { MapService } from './map.service';
import { ProjectService } from './project.service';
import { SearchService } from './search.service';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { Procedure, ProcedureCSVContent, ProcedureCsvModel, ProcedureModel, ProcedureNavaidAssociationModel, ProcedureNavaidAssociationTableColumnModel } from '../models/procedure';
import { HttpClient } from '@angular/common/http';
import { EndpointsService } from './endpoints.service';
import { ModalControlService } from './modal-control.service';
import { PointsService } from './points.service';
import { Observable, of } from 'rxjs';
import { ModalConfirmationService } from './modal-confirmation.service';
import { SelectCoordinatePointsControlService } from '../popup/services/select-coordinate-points-control.service';
import { Feature } from 'ol';
import { CoordinatePoint, CoordinatePointModel } from '../models/coordinate-point';
import * as olProj from 'ol/proj';
import LineString from 'ol/geom/LineString';
import { ProcedureLegModel } from '../models/procedure-leg';
import { ErrorModel } from '../models/error';
import { ProcedureCoordinatePointModel } from '../models/procedure-coordinate-point';
import { DynamicTable } from '../popup/dynamic-table/dynamic-table.component';
import { UtilsService } from './utils.service';
import { UiBlockService } from './ui-block.service';
import { NavaidModel } from '../models/navaid';
import { NavaidsService } from './navaids.service';
import { LatLonDMS } from '../models/coord-dms';
import { ConfigurationConstants, FeatureType } from '../models/EnumTypes';
import { greatCircleDistance } from "great-circle-distance";
import { ToolsControlService } from './tools-control.service';

import { ConfigurationService } from './configuration.service';
import { CurvePointDTO } from '../models/curvePointDTO';
import olMap from 'ol/Map';
import { toLonLat } from 'ol/proj';
import { SelectCoordinatePointComponent } from '../popup/select-coordinate-point/select-coordinate-point.component';
import { VicentyToolControlService } from './vicenty-tool-control.service';
import { clone, cloneDeep } from 'lodash';
import { EventsKey } from 'ol/events';
import { unByKey } from 'ol/Observable';
import { TabsService } from './tabsService';
import { ImportFileType } from '../models/ImportFileType';
import { CoordenateService } from './coordenate.service';
import { CoordinatePointsService } from './coordinate-points.service';
import { ChangeDetectorRef } from '@angular/core';
import { CoordPointDuplicationWarningComponent } from '../popup/coord-point-duplication-warning/coord-point-duplication-warning.component';
import Geometry from 'ol/geom/Geometry';
import { MultiPoint, Point } from 'ol/geom';
import { Coordinate } from 'ol/coordinate';


@Injectable({
  providedIn: 'root'
})
export class ProcedureControlService {

  private map: olMap
  public active: boolean;

  public procedureNavaidAssociationActive: boolean;
  public procedureNavaidModel : ProcedureNavaidAssociationModel;
  public fullScreenMode:boolean = false;


  edit;
  procedures : ProcedureModel[] = [];

  procedureFromAssessment: ProcedureModel;

  fixPointSelectOnMapActive : boolean = false;
  startPointSelectOnMapActive : boolean = false;
  airportSelectOnMapActive : boolean = false;
  endPointSelectOnMapActive : boolean = false;
  eventKey: EventsKey;
  createProcedureIDCount : number = 0;
  currentCreateProcedureID: number = 0;
  constructor(private projectService : ProjectService,
     private searchService : SearchService,
     private popupService : BsModalService,
     private globalSelectionService : GlobalSelectionControlService,
     private toolsService : ToolsControlService,
     private mapService : MapService,
     private http: HttpClient,
     private endpointService : EndpointsService,
     private modalService : ModalControlService,
     private pointsService : PointsService,
     private modalConfirmation : ModalConfirmationService,
     private utilsService : UtilsService,
     private uiBlock: UiBlockService,
     private navaidController : NavaidsService,
     private configurationService : ConfigurationService,
     public selectCoordinatePointService : SelectCoordinatePointsControlService,
     private vicentyService : VicentyToolControlService,
     private rcsControl: CoordenateService,
     public coordinatePointsService: CoordinatePointsService
    //public validationModalService : ValidationModalService,
     ) {

      this.map = this.mapService.getMap('map');

    /*this.pointsService.getProcedures().subscribe(
      (procedures) =>{
        procedures.forEach((procedure) =>{
          if(procedure.id > this.createProcedureIDCount)
            this.createProcedureIDCount = procedure.id;
        })
      })*/
   }

  createProcedure(procedureID: number, procedure?: ProcedureModel, route?:boolean) : void{
    if (this.projectService.projectEditable()){
    if(typeof procedure == 'undefined'){
      this.selectCoordinatePointService.selectedProcedure = new ProcedureModel();
    }
    else{
      this.selectCoordinatePointService.selectedProcedure = cloneDeep(procedure);
    }
    this.currentCreateProcedureID = procedureID;

    this.activateCreateProcedureWindow();
    if(route){
      this.globalSelectionService.clearAllSelectedExceptRouteSegment();
    }
    else{
      this.globalSelectionService.clearAllSelected();
    }
   }
  }




  setInitialStateOfCreateProcedureFromSelectedZone(cpFeatures: Feature[]) : void {
    if (!this.projectService.projectEditable()){
      return;
    }
    this.activateCreateProcedureWindow();
    this.globalSelectionService.clearAllSelected();
    let newProcedure : ProcedureModel = new ProcedureModel();
    newProcedure.procedureCoordinatePoints = this.createProcedureCoordinatePoints(cpFeatures);
    newProcedure.procedureLegs = this.createProcedureLegsFromProcedure(newProcedure);
    this.selectCoordinatePointService.selectedProcedure = newProcedure;
  }



  createProcedureFromCSV(model : ProcedureCsvModel,currentID?:number) : void {
    if (!this.projectService.projectEditable()){
      return;
    }
    if(model.fileContent.length > 1){
        let newProcedure : ProcedureModel = new ProcedureModel();
        newProcedure.procedureCoordinatePoints = [];
        let coordinatePointFeatures :Feature[] = this.pointsService.getAllCoordinatePointsFeaturesFromLayers()
        model.fileContent.forEach(element => {
          let newProcedureCoordinatePoint = new ProcedureCoordinatePointModel();
          newProcedureCoordinatePoint.coordPoint = this.transformProcedureCSVInCoordPoint(element);
          newProcedureCoordinatePoint.coordPoint.published = true;
          newProcedureCoordinatePoint.sequencenumber = Number.parseInt(element.sequenceNumber);
          newProcedureCoordinatePoint.procedurecoordpointtype = element.wtpType;
          newProcedureCoordinatePoint.altitude = Number.parseFloat(element.height);

          let coordPointFeature: Feature = coordinatePointFeatures.find(e => e.get('coordpointid') == element.coordinatePointId);
          let existingCoordPoint : CoordinatePoint
          if(coordPointFeature != null){
            existingCoordPoint  = this.pointsService.transformFeatureInCoordinatePoint(coordPointFeature);
          }
          if(existingCoordPoint != null && this.validateCoordPointDistance(newProcedureCoordinatePoint.coordPoint, existingCoordPoint)){
            newProcedureCoordinatePoint.coordPoint.id = existingCoordPoint.id;
            newProcedureCoordinatePoint.coordPoint.latitude = existingCoordPoint.latitude;
            newProcedureCoordinatePoint.coordPoint.latLonDms.fromLat(newProcedureCoordinatePoint.coordPoint.latitude);

            newProcedureCoordinatePoint.coordPoint.longitude = existingCoordPoint.longitude;
            newProcedureCoordinatePoint.coordPoint.latLonDms.fromLon(newProcedureCoordinatePoint.coordPoint.longitude);
          }
          // else{
          //   this.pointsService.addCoordinatePointToMap(newProcedureCoordinatePoint.coordPoint);
          // }
          newProcedure.procedureCoordinatePoints.push(newProcedureCoordinatePoint);
        });
        newProcedure.procedureLegs = this.createProcedureLegsFromProcedure(newProcedure,currentID);
        this.createProcedure(currentID,newProcedure)

    }else {
      this.modalService.showMesssageModal("Create Procedure","Please select more than one Coordinate Point.");
    }
  }

  validateCoordPointDistance(coordPoint : CoordinatePointModel, dbCoordPoint: CoordinatePoint): boolean{
    const coords = {
      lat1: coordPoint.latitude,
      lng1: coordPoint.longitude,
      lat2: dbCoordPoint.latitude,
      lng2: dbCoordPoint.longitude
    };
    var res = greatCircleDistance(coords) * 1000; //RESULT IN km -> m
    return res < ConfigurationConstants.COORDINATE_POINT_MAX_DISTANCE_METERS_SAME_ID;
  }

  transformProcedureCSVInCoordPoint(element : ProcedureCSVContent): CoordinatePointModel{
    let coordinate : CoordinatePointModel = new CoordinatePointModel();
    coordinate.altitude = Number.parseFloat(element.height);
    coordinate.coordpointid = element.coordinatePointId;
    coordinate.name = element.coordinatePointId;
    coordinate.latitude = Number.parseFloat(element.latitude);
    coordinate.longitude = Number.parseFloat(element.longitude);
    coordinate.latLonDms = new LatLonDMS();
    coordinate.latLonDms.fromLat(Number.parseFloat(element.latitude));
    coordinate.latLonDms.fromLon(Number.parseFloat(element.longitude));
    coordinate.type = "WAYPOINT";
    return coordinate;
  }


  openFooter(){
    this.active = true;
    this.createDblClickEvent();
  }

  createDblClickEvent(){
    let thisComponent = this;
    let thisSelectCoordinatePointControl = this.selectCoordinatePointService;
    let thisPointsService = this.pointsService;
    let thisModalService = this.modalService;
    let nearCoordPoints : CoordinatePointModel[] = [];
    let hitTolerance = 5;
    if (this.eventKey != null){
      unByKey(this.eventKey);
    }
    this.eventKey = this.map.on('dblclick', function(event){
      if(!this.globalSelectionService.skipClick){
        nearCoordPoints = [];
        let hit =   false;
        var coords = toLonLat(event.coordinate,this.rcsControl.activeRCS.isactive? this.rcsControl.activeRCS.epsg : "EPSG:3857");
        //var coords  = toLonLat(event.coordinate);
        let clickedCoordinates : CoordinatePointModel = new CoordinatePointModel();
        clickedCoordinates.latitude = Math.round(coords[1] * 100000) / 100000;
        clickedCoordinates.longitude = Math.round(coords[0] * 100000) / 100000;
        nearCoordPoints.push(clickedCoordinates);

        thisComponent.map.forEachFeatureAtPixel(
          event.pixel,
          function (feat : Feature) {
            if (feat.getGeometry() instanceof MultiPoint) {
              const geometry: MultiPoint = feat.getGeometry() as MultiPoint;
              const nearestPoint = geometry.getClosestPoint(event.coordinate);

              if (nearestPoint) { 
                const pointPixel = thisComponent.map.getPixelFromCoordinate(nearestPoint);
                const pixelDistance = Math.sqrt(
                  Math.pow(pointPixel[0] - event.pixel[0], 2) + 
                  Math.pow(pointPixel[1] - event.pixel[1], 2)
                );
                if (pixelDistance <= hitTolerance) { 
                  const pointFeature = thisComponent.pointsService.getCoordinatePointFeatureFromLayersByCoordinate
                  (
                    nearestPoint,
                    feat.get(CoordinatePointModel.LAYER_ID_FEATURE_PROPERTY),
                    feat.get(CoordinatePointModel.PUBLISHED_FEATURE_PROPERTY)
                  );
                  hit = true;
                  nearCoordPoints.push(thisPointsService.transformFeatureInCoordinatePoint(pointFeature));
                }
              }
            }
          },
          {
            hitTolerance: hitTolerance,
          }
        );
        if(thisComponent.active){
          var lat = clickedCoordinates.latitude;
          var long = clickedCoordinates.longitude;
          if(thisComponent.fixPointSelectOnMapActive && thisSelectCoordinatePointControl.isStraightlLeg == false){
            thisComponent.fixPointSelectOnMapActive = false;
            if (hit){
              thisSelectCoordinatePointControl.coordinatePointsModal = nearCoordPoints;
              thisSelectCoordinatePointControl.activeChangeFixPoint = true;
              const bsModalRef : BsModalRef = thisComponent.popupService.show(SelectCoordinatePointComponent);
            }else {
              let newCoordinatePoint : CoordinatePointModel = new CoordinatePointModel();
              thisSelectCoordinatePointControl.activeFixPoint.latitude = lat;
              thisSelectCoordinatePointControl.activeFixPoint.longitude = long;
              thisSelectCoordinatePointControl.activeFixPoint.latLonDms.fromLat(lat);
              thisSelectCoordinatePointControl.activeFixPoint.latLonDms.fromLon(long);
              thisSelectCoordinatePointControl.arcLength = thisComponent.mapService.convertMetersToNauticalMiles(thisSelectCoordinatePointControl.calculateDistance(thisSelectCoordinatePointControl.selectedProcedureLeg));
              thisSelectCoordinatePointControl.radius = thisComponent.mapService.convertMetersToNauticalMiles(VicentyToolControlService.calculateDistance(thisSelectCoordinatePointControl.selectedProcedureLeg.startPoint.coordPoint.latitude,
                thisSelectCoordinatePointControl.selectedProcedureLeg.startPoint.coordPoint.longitude,lat,long));
              newCoordinatePoint.latitude = lat;
              newCoordinatePoint.longitude = long;
              newCoordinatePoint.coordpointid = thisSelectCoordinatePointControl.selectedProcedureLeg.procedurelegid + "_fp";
              newCoordinatePoint.type = "FIX_POINT"
              newCoordinatePoint.name = thisSelectCoordinatePointControl.selectedProcedureLeg.procedurelegid + "_fix_point";
              newCoordinatePoint.nominalaltitude = 0;
              newCoordinatePoint.published = false;
              newCoordinatePoint.userdefined = true;

              let fixPoint : ProcedureCoordinatePointModel = new ProcedureCoordinatePointModel();
              fixPoint.altitude = 0;

              fixPoint.coordPoint = newCoordinatePoint;
              fixPoint.isCurvePoint = false;

              thisComponent.deleteLegWithId(thisSelectCoordinatePointControl.selectedProcedureLeg.procedurelegid);

              let newProcedureLeg : ProcedureLegModel = cloneDeep(thisSelectCoordinatePointControl.selectedProcedureLeg);
              newProcedureLeg.curvePoints = [];
              newProcedureLeg.fixPoint = fixPoint;
              newProcedureLeg.ismodified = false;
              newProcedureLeg.isstraightleg = false;

              thisSelectCoordinatePointControl.selectedProcedureLeg.ismodified = true;
              thisSelectCoordinatePointControl.calculateCurvePoints(newProcedureLeg);
              thisSelectCoordinatePointControl.tempProcedureLeg.push(newProcedureLeg);
              thisSelectCoordinatePointControl.addLegToMap(newProcedureLeg, thisSelectCoordinatePointControl.selectedProcedure, true);
              thisSelectCoordinatePointControl.selectLegFeature(newProcedureLeg, thisSelectCoordinatePointControl.selectedProcedure);
            }
            thisComponent.fixPointSelectOnMapActive = false;
            return;
          }else if (thisComponent.startPointSelectOnMapActive){
            thisComponent.startPointSelectOnMapActive = false;
            if (hit){
              thisSelectCoordinatePointControl.coordinatePointsModal = nearCoordPoints;
              thisSelectCoordinatePointControl.activeChangeStartPoint = true;
              const bsModalRef : BsModalRef = thisComponent.popupService.show(SelectCoordinatePointComponent);
            }else {
              let emptyProcedureCoordinatePoint : ProcedureCoordinatePointModel = new ProcedureCoordinatePointModel();
              let emptyCoordPoint: CoordinatePointModel = new CoordinatePointModel();
              emptyCoordPoint.coordpointid = "";
              emptyCoordPoint.name = "";
              emptyCoordPoint.empty = true;
              emptyCoordPoint.type = "WAYPOINT";
              emptyCoordPoint.nominalaltitude = 0;
              emptyCoordPoint.published = false;
              emptyCoordPoint.longitude = long;
              emptyCoordPoint.latitude = lat;
              emptyProcedureCoordinatePoint.coordPoint = emptyCoordPoint;

              const index = thisSelectCoordinatePointControl.selectedProcedure.procedureCoordinatePoints.findIndex(pcp =>
                thisSelectCoordinatePointControl.selectedProcedureLeg.startPoint.sequencenumber == pcp.sequencenumber);
              if (index > -1) {
                emptyProcedureCoordinatePoint.sequencenumber = thisSelectCoordinatePointControl.selectedProcedure.procedureCoordinatePoints[index].sequencenumber;
                thisSelectCoordinatePointControl.selectedProcedure.procedureCoordinatePoints.splice(index, 1);
              }

              thisSelectCoordinatePointControl.selectedProcedureLeg.startPoint.coordPoint = emptyCoordPoint;

              thisSelectCoordinatePointControl.selectedProcedure.procedureCoordinatePoints.splice(index, 0, emptyProcedureCoordinatePoint);
            }

          }else if (thisComponent.endPointSelectOnMapActive){
            thisComponent.endPointSelectOnMapActive = false;
            if (hit){
              thisSelectCoordinatePointControl.activeChangeEndPoint = true;
              thisSelectCoordinatePointControl.coordinatePointsModal = nearCoordPoints;
              const bsModalRef : BsModalRef = thisComponent.popupService.show(SelectCoordinatePointComponent);
            }else {
              let emptyProcedureCoordinatePoint : ProcedureCoordinatePointModel = new ProcedureCoordinatePointModel();
              let emptyCoordPoint: CoordinatePointModel = new CoordinatePointModel();
              emptyCoordPoint.coordpointid = "";
              emptyCoordPoint.name = "";
              emptyCoordPoint.empty = true;
              emptyCoordPoint.type = "WAYPOINT";
              emptyCoordPoint.nominalaltitude = 0;
              emptyCoordPoint.published = false;
              emptyCoordPoint.longitude = long;
              emptyCoordPoint.latitude = lat;
              emptyProcedureCoordinatePoint.coordPoint = emptyCoordPoint;
              const index = thisSelectCoordinatePointControl.selectedProcedure.procedureCoordinatePoints.findIndex(pcp =>
                thisSelectCoordinatePointControl.selectedProcedureLeg.endPoint.sequencenumber == pcp.sequencenumber);
              if (index > -1) {
                emptyProcedureCoordinatePoint.sequencenumber = thisSelectCoordinatePointControl.selectedProcedure.procedureCoordinatePoints[index].sequencenumber;
                thisSelectCoordinatePointControl.selectedProcedure.procedureCoordinatePoints.splice(index, 1);
              }
              thisSelectCoordinatePointControl.selectedProcedureLeg.endPoint.coordPoint = emptyCoordPoint;

              thisSelectCoordinatePointControl.selectedProcedure.procedureCoordinatePoints.splice(index, 0, emptyProcedureCoordinatePoint);

            }
          }else if (thisComponent.airportSelectOnMapActive){
            thisComponent.airportSelectOnMapActive = false;
            let coordPoints : CoordinatePointModel[] = nearCoordPoints.filter( point => point.type == "ARP_CIVIL" || point.type == "ARP_MILITAR" || point.type == "ARP_MIXED");
            if (hit && coordPoints.length > 0){
              thisSelectCoordinatePointControl.activeChangeAirport = true;
              thisSelectCoordinatePointControl.coordinatePointsModal = coordPoints;
              const bsModalRef : BsModalRef = thisComponent.popupService.show(SelectCoordinatePointComponent);
            } else {
              thisModalService.showMesssageModal("Manage Procedure", "No airports found.");
            }

          } else {

            if (hit){
              thisSelectCoordinatePointControl.coordinatePointsModal = nearCoordPoints;
              thisSelectCoordinatePointControl.createProcedureTempID = thisComponent.currentCreateProcedureID;
              const bsModalRef : BsModalRef = thisComponent.popupService.show(SelectCoordinatePointComponent);
            } else {
              let emptyProcedureCoordinatePoint : ProcedureCoordinatePointModel = new ProcedureCoordinatePointModel();
              let emptyCoordPoint: CoordinatePointModel = new CoordinatePointModel();
              emptyCoordPoint.coordpointid = "";
              emptyCoordPoint.name = "";
              emptyCoordPoint.empty = true;
              emptyCoordPoint.type = "WAYPOINT";
              emptyCoordPoint.nominalaltitude = 0;
              emptyCoordPoint.published = false;
              emptyCoordPoint.longitude = long;
              emptyCoordPoint.latitude = lat;
              emptyProcedureCoordinatePoint.coordPoint = emptyCoordPoint;
              const pcpLength = thisSelectCoordinatePointControl.selectedProcedure.procedureCoordinatePoints.length;
              if (pcpLength > 0){
                emptyProcedureCoordinatePoint.sequencenumber = thisSelectCoordinatePointControl.selectedProcedure.procedureCoordinatePoints[pcpLength-1].sequencenumber + 1;
              } else {
                emptyProcedureCoordinatePoint.sequencenumber = 0;
              }

              thisSelectCoordinatePointControl.selectedProcedure.procedureCoordinatePoints.push(emptyProcedureCoordinatePoint);

              if(thisSelectCoordinatePointControl.selectedProcedure.procedureCoordinatePoints.length > 1){
                let coordPointsLength : number = thisSelectCoordinatePointControl.selectedProcedure.procedureCoordinatePoints.length;
                let newStartPoint : ProcedureCoordinatePointModel = new ProcedureCoordinatePointModel();
                newStartPoint.altitude = 0;
                newStartPoint.coordPoint = thisSelectCoordinatePointControl.selectedProcedure.procedureCoordinatePoints[coordPointsLength - 2].coordPoint;
                newStartPoint.isCurvePoint = false;
                let newEndPoint : ProcedureCoordinatePointModel = new ProcedureCoordinatePointModel();
                newEndPoint.altitude = 0;
                newEndPoint.coordPoint = thisSelectCoordinatePointControl.selectedProcedure.procedureCoordinatePoints[coordPointsLength - 1].coordPoint;
                newEndPoint.isCurvePoint = false;
                let newLeg: ProcedureLegModel = new ProcedureLegModel();
                newLeg.isstraightleg = true;
                newLeg.startPoint = newStartPoint;
                newLeg.endPoint = newEndPoint;
                newLeg.procedurelegid = thisSelectCoordinatePointControl.getLegId();
                // thisSelectCoordinatePointControl.addLegToMap(newLeg, thisSelectCoordinatePointControl.selectedProcedure);
                thisSelectCoordinatePointControl.selectedProcedure.procedureLegs.push(newLeg);
              }
            }
          }

        }
        if(thisSelectCoordinatePointControl.selectedProcedure.procedureCoordinatePoints.length > 1){
          const legsWithFixPoint = thisComponent.selectCoordinatePointService.getLegsWithFixPoint(thisSelectCoordinatePointControl.selectedProcedure);
          thisComponent.selectCoordinatePointService.deleteProcedureLegsOnMap(thisSelectCoordinatePointControl.selectedProcedure);
          thisSelectCoordinatePointControl.selectedProcedure.procedureLegs = [];
          if(!thisComponent.edit){
            thisComponent.selectCoordinatePointService.createLegsFromProcedureCoordinatePoints(thisSelectCoordinatePointControl.selectedProcedure, legsWithFixPoint, thisSelectCoordinatePointControl.tempProcedureLeg,thisComponent.currentCreateProcedureID);
          }
          else{
            thisComponent.selectCoordinatePointService.createLegsFromProcedureCoordinatePoints(thisSelectCoordinatePointControl.selectedProcedure, legsWithFixPoint, thisSelectCoordinatePointControl.tempProcedureLeg);
          }
        }

      }
    }.bind(this));
    console.log();
  }
  deleteLegWithId(procedureLegId : string){
    this.selectCoordinatePointService.tempProcedureLeg.forEach( temp_leg => {
      if(procedureLegId == temp_leg.procedurelegid){
        this.selectCoordinatePointService.deleteTempLegOnMap(temp_leg);
        let index : number = this.selectCoordinatePointService.tempProcedureLeg.indexOf(temp_leg);
        if(index != -1) {
          this.selectCoordinatePointService.tempProcedureLeg.splice(index, 1);
        }

      }

    })
  }
  hideFooter(){
    this.active = false;
    unByKey(this.eventKey);
    /*
    this.selectCoordinatePointService.deleteProcedureLegsOnMap(this.selectCoordinatePointService.selectedProcedure);
    this.pointsService.addProcedureToMap(this.selectCoordinatePointService.selectedProcedure);*/
  }

  restoreMap(procedure?: ProcedureModel,createProcedureID?:number){
    if(typeof procedure == 'undefined'){
      procedure= this.selectCoordinatePointService.selectedProcedure;
    }
    if(typeof createProcedureID  == 'undefined'){
      createProcedureID = this.currentCreateProcedureID;
    }
    let source = this.selectCoordinatePointService.getLayerSourceFromProcedureType(procedure.proceduretype);
    if(procedure.id != null ){
      this.pointsService.getAllProceduresFeaturesFromLayers().forEach((feature) => {
          if (
            this.selectCoordinatePointService.selectedProcedure.procedureid ==
            feature.get("procedureid") || (feature.get("procedureid") as string).includes(`assmentTempProcedure|${this.selectCoordinatePointService.selectedProcedure.procedureid}`)
          ) {
            this.selectCoordinatePointService.getLayerSourceFromProcedureType(feature.get("type")).removeFeature(feature);
          }
      })
    }
    else{
      this.pointsService.getAllProceduresFeaturesFromLayers().forEach((feature) => {
        if (
          'TEMP_CREATE_PROCEDURE_'+ createProcedureID ==
          feature.getProperties().id || 'TEMP_CREATE_PROCEDURE_undefined' ==  feature.getProperties().id // TODO: figure out the id of some temporary legs is 'TEMP_CREATE_PROCEDURE_undefined'
        ) {
           this.selectCoordinatePointService.getLayerSourceFromProcedureType(feature.get("type")).removeFeature(feature);
        }
    })
    }
    this.globalSelectionService.clearAllSelected();
    this.pointsService.deleteCoordinatePointsFromMap();
    if(procedure.id != null) {
      this.pointsService.getProcedureByID(procedure.id.toString()).subscribe( (proc : ProcedureModel) => {
        this.addCoordinatePointsFromLegs(proc);

        this.pointsService.addProcedureToMap(proc);
      })
    }

    this.pointsService.fetchAndAddCoordinatePoints();
  }
  closeFooter(save:boolean=false){
    this.hideFooter();
    if(save){
      return;
    }
    if (this.selectCoordinatePointService.selectedProcedure.latLonNotEditable){ // means procedure is from procedure assessment
      this.procedureFromAssessment = undefined;
    }
    this.selectCoordinatePointService.tempProcedureLeg = [];
    this.restoreMap();
  }
  activateCreateProcedureWindow() : void {
    this.selectCoordinatePointService.activeFixPoint = new CoordinatePointModel();
    this.selectCoordinatePointService.selectedProcedureLeg = undefined;
    this.selectCoordinatePointService.radius = 0;
    this.selectCoordinatePointService.arcLength = 0;
    this.selectCoordinatePointService.isStraightlLeg = true;
    this.selectCoordinatePointService.actualLetId = undefined;
    this.selectCoordinatePointService.tempProcedureLeg = [];
    this.selectCoordinatePointService.originalProcedureID = "";
    //this.menuService.toogleMenu();
    this.selectCoordinatePointService.selectedAirport = undefined;
    this.openFooter();
    this.setAirportsCoordinatePoint();
    this.globalSelectionService.coordinatePointsLayers.childLayers.forEach( child => {
      child.showAll();
    });
    this.selectCoordinatePointService.setValidationValid(true);
    this.edit = false;
  }

  createProcedureCoordinatePoints( features : Feature[]) : ProcedureCoordinatePointModel[]{
    let procedureCoordinatePoints : ProcedureCoordinatePointModel[] = [];
    let index : number = 0;

    features.forEach( feat => {
      let newProcedureCoordinatePoint = new ProcedureCoordinatePointModel();
      newProcedureCoordinatePoint.coordPoint = this.pointsService.transformFeatureInCoordinatePoint(feat);
      newProcedureCoordinatePoint.coordPoint.published = true;
      newProcedureCoordinatePoint.sequencenumber = index;
      index++;
      procedureCoordinatePoints.push(newProcedureCoordinatePoint);
    });

    return procedureCoordinatePoints;
  }

  createProcedureCoordinatePointsFromCoordinatePoints( data ) : ProcedureCoordinatePointModel[]{
    let procedureCoordinatePoints : ProcedureCoordinatePointModel[] = [];
    let index : number = 0;

    data.forEach( pointResponse => {
      let newProcedureCoordinatePoint = new ProcedureCoordinatePointModel();
      newProcedureCoordinatePoint.coordPoint = pointResponse;
      newProcedureCoordinatePoint.sequencenumber = index;
      newProcedureCoordinatePoint.coordPoint.published = true;
      index++;
      procedureCoordinatePoints.push(newProcedureCoordinatePoint);
    });

    return procedureCoordinatePoints;
  }
  cancelProcedure():void{
    this.active = false;
    this.toolsService.navigationOnTop = false;
    this.pointsService.deleteAllProceduresFromMap();
    this.pointsService.deleteCoordinatePointsFromMap();
    this.pointsService.fetchAndAddProcedures();
    this.pointsService.fetchAndAddCoordinatePoints();
    this.globalSelectionService.clearAllSelected();
  }

  setEditProcedureFromAssessment() {
    this.selectCoordinatePointService.selectedProcedure = this.procedureFromAssessment;
    this.edit = true;
    this.setEditProcedureDataAux();

  }

  private setEditProcedureDataAux() : void {
    if(this.selectCoordinatePointService.selectedProcedure.referenceAirportPk != null) {
      let coordPoints: Feature[] = this.pointsService.getAllCoordinatePointsFeaturesFromLayers();
      let coordPoint : CoordinatePointModel = this.pointsService.transformFeatureInCoordinatePoint(coordPoints.find((point: Feature) => point.get('id') ==  this.selectCoordinatePointService.selectedProcedure.referenceAirportPk));
      this.selectCoordinatePointService.selectedAirport = coordPoint;
      this.selectCoordinatePointService.selectedAirport.composedName = coordPoint.coordpointid + ' - ' + coordPoint.name;

    }
    this.setAirportsCoordinatePoint();
    this.selectCoordinatePointService.actualLetId = this.selectCoordinatePointService.selectedProcedure.actualLegId;
    const legsWithFixPoint = this.selectCoordinatePointService.getLegsWithFixPoint(this.selectCoordinatePointService.selectedProcedure);
    //this.selectCoordinatePointService.deleteProcedureLegsOnMap(this.selectCoordinatePointService.selectedProcedure);
    this.pointsService.deleteProcedureModelFromMap(this.selectCoordinatePointService.selectedProcedure);
    this.selectCoordinatePointService.selectedProcedure.procedureLegs = [];
    this.selectCoordinatePointService.createLegsFromProcedureCoordinatePoints(this.selectCoordinatePointService.selectedProcedure, legsWithFixPoint);
    this.selectCoordinatePointService.originalProcedureID = this.selectCoordinatePointService.selectedProcedure.procedureid;
    //this.menuService.toogleMenu();
    this.toolsService.navigationOnTop = true;
    this.globalSelectionService.coordinatePointsLayers.childLayers.forEach( child => {
      child.showAll();
    });
  }


  setEditProcedure(procedure : ProcedureModel){
    this.selectCoordinatePointService.selectedProcedure = procedure;
    this.selectCoordinatePointService.selectedProcedure.navaids = this.selectCoordinatePointService.selectedProcedure.navaids.concat(this.selectCoordinatePointService.selectedProcedure.criticalNavaids);
    this.selectCoordinatePointService.tempProcedureLeg = [];
    this.edit = true;
    this.setEditProcedureDataAux();

  }

  getEditProcedureFeatures() {
    let proceduremodel: ProcedureModel;

    this.selectCoordinatePointService.activeFixPoint = new CoordinatePointModel();
    this.selectCoordinatePointService.selectedProcedureLeg = undefined;
    this.selectCoordinatePointService.radius = 0;
    this.selectCoordinatePointService.arcLength = 0;
    //this.selectCoordinatePointService.isStraightlLeg = true;
    this.selectCoordinatePointService.tempProcedureLeg = [];
    this.selectCoordinatePointService.selectedAirport = undefined;
    let features : Feature[] = this.pointsService.getSelectedFeatures().filter(feat => feat.get("featureType") == FeatureType.Procedure);
    this.globalSelectionService.clearAllSelected();
    if(features.length > 0){
      return features
    }
    else{
      this.modalService.showMesssageModal("Warning", "Select at least 1 Procedure to edit.");
    }

  }

  setAirportsCoordinatePoint() : void {
    this.selectCoordinatePointService.airportsCoordinatePoints = [];
    let ARPCivilVectorSource = this.pointsService.coordinatePointsLayers.childLayers[0].layers
      .find((element) => element.id == 'arp_civil')
      .olLayer;
      let ARPMilitaryVectorSource = this.pointsService.coordinatePointsLayers.childLayers[0].layers
      .find((element) => element.id == 'arp_militar')
      .olLayer;
      let ARPMixedVectorSource = this.pointsService.coordinatePointsLayers.childLayers[0].layers
      .find((element) => element.id == 'arp_mixed')
      .olLayer;

    let source = ARPCivilVectorSource.getSource();
    source.getFeatures().forEach( feat => {
      this.selectCoordinatePointService.airportsCoordinatePoints.push(this.pointsService.transformFeatureInCoordinatePoint(feat));
    })

    source = ARPMilitaryVectorSource.getSource();
    source.getFeatures().forEach( feat => {
      this.selectCoordinatePointService.airportsCoordinatePoints.push(this.pointsService.transformFeatureInCoordinatePoint(feat));
    })

    source = ARPMixedVectorSource.getSource();
    source.getFeatures().forEach( feat => {
      this.selectCoordinatePointService.airportsCoordinatePoints.push(this.pointsService.transformFeatureInCoordinatePoint(feat));
    })
  }

  saveProcedureCSV(procedure: ProcedureModel){
    return this.http
    .post(
      this.endpointService.apiUrlProcedures,
      procedure,
      this.endpointService.httpOptions
    );
  }
  storeProcedure(procedure: ProcedureModel){
    if(procedure.id == null){ //create
      return this.http
          .post(
            this.endpointService.apiUrlProcedures,
            procedure,
            this.endpointService.httpOptions
            );
    }
    else{ // edit
      return this.http
          .put(
            this.endpointService.apiUrlProcedures,
            procedure,
            this.endpointService.httpOptions
            );
    }
  }
  restoreMapAfterSave(data : ErrorModel[], savedProcedure: ProcedureModel){
    let updateAssociatedNavaids: boolean = false;
    if(data[0].code == 'OK'){
      updateAssociatedNavaids = true;
      if(savedProcedure.id == null){
        this.modalService.showMesssageModal('Procedure', 'Procedure created successfully.');
      }
      else{
        this.modalService.showMesssageModal('Procedure', 'Procedure updated successfully.');
      }
    }else {
      let message : string  = '';
      data.forEach( error => {
        if (message.length < 0){
          message = message + error.message + ';';
        }else {
          message = message + ' ' + error.message + ';';
        }
      });
      if(savedProcedure.id == null){
        this.modalService.showMesssageModal("Error", "Error creating procedure." + message);
      }
      else{
        this.modalService.showMesssageModal("Error", "Error updating procedure" + message);
      }
    }
    //this.pointsService.deleteNavaidsFromMap();
    //this.pointsService.fetchAndAddNavaids();
    this.pointsService.deleteCoordinatePointsFromMap();
    this.pointsService.fetchAndAddCoordinatePoints();

    this.pointsService.deleteAllProceduresFromMap();
    this.pointsService.fetchAndAddProcedures(updateAssociatedNavaids);

    this.pointsService.zoomToProcedures([savedProcedure]);
    this.pointsService.clearSelectedFeatures();
  }

  storeProcedureAndRestoreMap(procedure: ProcedureModel, tabsService?: TabsService){
    this.uiBlock.startBlock("Saving Procedure...")
    this.storeProcedure(procedure)
    .subscribe((data : ErrorModel[]) =>{

      this.restoreMapAfterSave(data,procedure);
      if(this.active){
        tabsService.closeTab(undefined,false,false,true);
      }
      this.uiBlock.stopBlock()
    },
    (error) => {
      if (error && error.status == 401) {
        this.modalService.showMesssageModal(
          'Error',
          'Default Project is not editable.'
        )
        return;
      }
      if(procedure.id == null){
        this.modalService.showMesssageModal("Error", "Error creating procedure.");
        this.uiBlock.stopBlock()
      }
      else{
        this.modalService.showMesssageModal("Error", "Error updating procedure.");
        this.uiBlock.stopBlock()
      }
    })
  }
  saveProcedureCheckCoordPointDuplicates(procedure: ProcedureModel,tabsService?: TabsService){
    let procedureCoordinatePoints: CoordinatePointModel[] = [];
    procedure.procedureCoordinatePoints.forEach((proc_point) => procedureCoordinatePoints.push(proc_point.coordPoint));
    let duplicates = this.pointsService.getDuplicatesOfCPList(procedureCoordinatePoints);
    if(duplicates.length == 0){
      this.storeProcedureAndRestoreMap(procedure,tabsService);
      return;
    }
    const bsRef: BsModalRef = this.popupService.show(CoordPointDuplicationWarningComponent, {
      backdrop: 'static' // Prevent closing on backdrop click
    });
    bsRef.content.duplicateCoordinatePoints = duplicates
    bsRef.content.onUserResponse.subscribe((result) =>{
        switch(result){
          case CoordPointDuplicationWarningComponent.CANCEL:
            if(this.active && !tabsService.minimizeScreenMode){
              tabsService.showTab(tabsService.currentIndex);
            }
            break;
          case CoordPointDuplicationWarningComponent.PROCEED:
            this.storeProcedureAndRestoreMap(procedure,tabsService);
            break;
        }
      })
  }
  saveProcedure(procedure: ProcedureModel,tabsService?: TabsService): void {
    if(this.edit){
      this.storeProcedureAndRestoreMap(procedure,tabsService);
    }
    else{
      this.saveProcedureCheckCoordPointDuplicates(procedure,tabsService);
    }
  }

  bulkStatusUpdateProcedure(procedures: ProcedureModel[]): void {
      this.http
        .put(
          this.endpointService.apiUrlProceduresBulkStatusUpdate,
          procedures,
          this.endpointService.httpOptions
        )
        .subscribe(
          (data : boolean) => {
            this.pointsService.deleteNavaidsFromMap();
            this.pointsService.fetchAndAddNavaids();
            this.pointsService.deleteCoordinatePointsFromMap();
            this.pointsService.fetchAndAddCoordinatePoints();
            this.pointsService.deleteAllProceduresFromMap();
            this.pointsService.fetchAndAddProcedures();
            this.pointsService.clearSelectedFeatures();
            if(data == true){
              this.modalService.showMesssageModal('Procedure', 'Procedures updated successfully.');
            }
          },
          (error) => {
            this.modalService.showMesssageModal("Error", "Error updating procedures.");
          }
        );
  }

  public addProcedureLegsToMap(procedure : ProcedureModel) {
    let sidSource = this.pointsService.proceduresLayers.childLayers[0].layers
      .find((element) => element.id === 'sid')
      .olLayer.getSource();
    let enrouteSource = this.pointsService.proceduresLayers.childLayers[0].layers
      .find((element) => element.id === 'enroute')
      .olLayer.getSource();
    let starSource = this.pointsService.proceduresLayers.childLayers[0].layers
      .find((element) => element.id === 'star')
      .olLayer.getSource();
    let assessmentSource = this.pointsService.proceduresLayers.childLayers[0].layers
      .find((element) => element.id === 'assessment')
      .olLayer.getSource();

    let marker : Feature[] = this.createProcedureLegFeatures(procedure);
    switch (procedure.proceduretype) {
      case 'SID':{
        marker.forEach( feat => {
          sidSource.addFeature(feat);
        });
        break;
      }
      case 'STAR':
        marker.forEach( feat => {
          starSource.addFeature(feat);
        });
        break;
      case 'ENROUTE':
        marker.forEach( feat => {
          enrouteSource.addFeature(feat);
        });
        break;
      case 'ASSESSMENT':
        marker.forEach( feat => {
          assessmentSource.addFeature(feat);
        });
      default:
        break;
    }
  }

  private createProcedureLegFeatures(obj: ProcedureModel): Feature[] {
    let features : Feature[] = [];

    for (let index = 0; index < obj.procedureLegs.length; index++) {
      let points = [];
      points.push([
        obj.procedureLegs[index].startPoint.coordPoint.longitude,
        obj.procedureLegs[index].startPoint.coordPoint.latitude,
      ]);
      if (index == 0) {
        //first
        if(!obj.procedureLegs[index].isstraightleg){
          obj.procedureLegs[index].curvePoints.forEach(curvePoint => {
            points.push([curvePoint.longitude,curvePoint.latitude]);
          });
        }
        points.push([
          obj.procedureLegs[index].endPoint.coordPoint.longitude,
          obj.procedureLegs[index].endPoint.coordPoint.latitude,
        ]);
      } else if (index == obj.procedureLegs.length - 1) {
        //last
        if(!obj.procedureLegs[index].isstraightleg){
          obj.procedureLegs[index].curvePoints.forEach(curvePoint => {
            points.push([curvePoint.longitude,curvePoint.latitude]);
          });
        }
        points.push([
          obj.procedureLegs[index].endPoint.coordPoint.longitude,
          obj.procedureLegs[index].endPoint.coordPoint.latitude,
        ]);
      } else {
        if(!obj.procedureLegs[index].isstraightleg){
          obj.procedureLegs[index].curvePoints.forEach(curvePoint => {
            points.push([curvePoint.longitude,curvePoint.latitude]);
          });
        }
        points.push([
          obj.procedureLegs[index].endPoint.coordPoint.longitude,
          obj.procedureLegs[index].endPoint.coordPoint.latitude,
        ]);
      }

      for (var i = 0; i < points.length; i++) {
        points[i] = olProj.transform(points[i], 'EPSG:4326', this.mapService.getMaps().getView().getProjection());
      }

      let feat = new Feature({
        geometry: new LineString(points),
        id: obj.id,
        name: obj.name,
        procedureid: obj.procedureid,
        proceduretype: obj.proceduretype,
        type: obj.proceduretype,
        selectedOnManage: false,
        featureId: obj.procedureLegs[index].procedurelegid,
        featureType : 2//procedure

      });

      features.push(feat);

    }

    return features;
  }

  deleteProcedure() : void {
    if (!this.projectService.projectEditable()){
      return;
    }
    let features : Feature[] = this.pointsService.getSelectedFeatures().filter(feat => feat.get("featureType") == 2);
    if(features.length == 0){
      this.modalService.showMesssageModal("Warning", "Select at least 1 Procedure to delete.");
      return;
    }
    const bsModalRef : BsModalRef = this.popupService.show(DynamicTable, {
      backdrop: 'static' // Prevent closing on backdrop click
    });
    bsModalRef.content.entity = "Procedures";
    bsModalRef.content.type = "Delete";
    bsModalRef.content.selectAllActive = true;
    bsModalRef.content.data = features;
    bsModalRef.content.displayedColumns = this.utilsService.getDynamicTableColumns("Procedures");
    bsModalRef.content.onClose.subscribe(result => {
      if(result.length>0){
        let list : Feature[] = [];
        result.forEach(element => {
          list.push(this.pointsService.getSelectedFeatures().find(x => x.get("id") == element.get("id") && x.get("featureType") == 2));
        });
        this.modalConfirmation.showMesssageConfirmationModal("Delete Procedure", "Do you want to delete the selected Procedure?", "Yes", "No", () => this.deleteProcedures(list, true));
      }
    });
    //this.menuService.toogleMenu();
  }

  public deleteProcedures(features : any, fromMapAndDatabase : boolean): void {
    this.uiBlock.startBlock("Deleting procedures...");
    let procedures : ProcedureModel[] = [];

    for(let feature of features){
      let proc : ProcedureModel = this.transformFeatureInProcedure(feature);
      procedures.push(proc);
    }
    this.pointsService.deleteProcedureBulk(procedures).subscribe(
      (result) => {
        let source;
        features.forEach((feature) => {
          switch(feature.get('type')){
            case "SID":
              source = this.pointsService.proceduresLayers.childLayers[0].layers
              .find((element) => element.id === 'sid')
              .olLayer.getSource();
              break;
            case "STAR":
              source = this.pointsService.proceduresLayers.childLayers[0].layers
              .find((element) => element.id === 'star')
              .olLayer.getSource();
              break;
            case "ENROUTE":
              source = this.pointsService.proceduresLayers.childLayers[0].layers
              .find((element) => element.id === 'enroute')
              .olLayer.getSource();
              break;
          }
            source.removeFeature(feature);
            this.pointsService.removeSelectedFeature(feature);

            // update navaid's associated procedures list
            if (feature.get("navaids") != null && feature.get("navaids").length > 0){
              for (const navaid of feature.get("navaids") as NavaidModel[]){
                const navaidFeature: Feature<Geometry> = this.pointsService.getNavaidFeatureFromLayers(navaid.id.toString());
                const associatedProcedures: ProcedureModel[] = navaidFeature.get("associatedProcedures");
                const index = associatedProcedures.findIndex(p => p.id == feature.get("id"));
                if (index != -1){
                  associatedProcedures.splice(index, 1);
                  navaidFeature.set("associatedProcedures", associatedProcedures);
                }
              }
            }
            if (feature.get("criticalNavaids") != null && feature.get("criticalNavaids").length > 0){
              for (const navaid of feature.get("criticalNavaids") as NavaidModel[]){
                const navaidFeature: Feature<Geometry> = this.pointsService.getNavaidFeatureFromLayers(navaid.id.toString());
                const associatedProcedures: ProcedureModel[] = navaidFeature.get("associatedProceduresCritical");
                const index = associatedProcedures.findIndex(p => p.id == feature.get("id"));
                if (index != -1){
                  associatedProcedures.splice(index, 1);
                  navaidFeature.set("associatedProceduresCritical", associatedProcedures);
                }
              }
            }
        });
        for (const procedure of procedures){
          const procedureConfigIndex: number = this.configurationService.currentConfiguration.procedures.findIndex(p => p.id == procedure.id);
          if (procedureConfigIndex != -1){
            this.configurationService.currentConfiguration.procedures.splice(procedureConfigIndex, 1);
          }
        }

        this.modalService.showMesssageModal("Procedures", "Procedures deleted with success.");
        this.uiBlock.stopBlock();
      },
      (error) => {
        this.uiBlock.stopBlock();
        if (error && error.status == 401) {
          this.modalService.showMesssageModal(
            'Error Deleting',
            'Default Project is not editable.'
          )
          return;
        }
        this.modalService.showMesssageModal(
          'Error Deleting',
          `Error deleting procedures.`
        );
      });

  }

  deleteProcedureFromDb(id: string): Observable<boolean> {
    this.http
      .delete<boolean>(
        this.endpointService.apiUrlProcedures + '/' + id,
        this.endpointService.httpOptions
      )
      .subscribe(
        () => {
          const procedureConfigIndex: number = this.configurationService.currentConfiguration.procedures.findIndex(p => p.id.toString() == id);
          if (procedureConfigIndex != -1){
            this.configurationService.currentConfiguration.procedures.splice(procedureConfigIndex, 1);
          }
          return true;
        },
        (error) => {
          if (error && error.status == 401) {
            this.modalService.showMesssageModal(
              'Error Deleting',
              'Default Project is not editable.'
            )
            return false;
          }
          this.modalService.showMesssageModal(
            'Error Deleting',
            `Error deleting procedures.`
          );
          return false;
        }
      );
    return of(false);
  }

  transformFeatureInProcedure(
    arg0: Feature<import('ol/geom/Geometry').default>
  ): ProcedureModel {
    let model: ProcedureModel = new ProcedureModel();
    model.id = arg0.get('id');
    model.procedureid = arg0.get('procedureid');
    model.name = arg0.get('name');
    model.proceduretype = arg0.get('proceduretype');
    model.referenceAirportPk = arg0.get('referenceairportpk');
    model.rnavperformancetype = arg0.get('rnavperformancetype');
    model.mapstatus = arg0.get('mapstatus');
    model.aircraftspeed = arg0.get('aircraftspeed');
    model.airport = arg0.get('airport');
    model.freetext = arg0.get('freetext');
    model.procedureLegs = arg0.get('procedurelegs');
    model.iDNotEditable = arg0.get('iDNotEditable');
    model.latLonNotEditable = arg0.get('latLonNotEditable');

    let coordPoints : ProcedureCoordinatePointModel[] = [];
    let i = 0;
    let coordPointSequenceNumber = 0;
    model.procedureLegs.forEach( leg => {
      if (!(coordPoints.filter(e => e.id == leg.startPoint.id).length > 0) ) {
        //leg.startPoint.coordPoint.wtype = leg.startPoint.procedurecoordpointtype;
        leg.startPoint.coordPoint.altitude = leg.startPoint.altitude;
        if (leg.startPoint.coordPoint.published == undefined){
          leg.startPoint.coordPoint.published = true;
        }
        leg.startPoint.sequencenumber = coordPointSequenceNumber++;
        coordPoints.push(leg.startPoint);
      }
      if (!(coordPoints.filter(e => e.id == leg.endPoint.id).length > 0)) {
        //leg.endPoint.coordPoint.wtype = leg.endPoint.procedurecoordpointtype;
        leg.endPoint.coordPoint.altitude = leg.endPoint.altitude;
        if (leg.endPoint.coordPoint.published == undefined){
          leg.endPoint.coordPoint.published = true;
        }
        leg.endPoint.sequencenumber = coordPointSequenceNumber++;
        coordPoints.push(leg.endPoint);
      }
      i++;
    });

    model.procedureCoordinatePoints = coordPoints;
    model.actualLegId = i - 1;


    // This actions are needed to apply the date conversion for each date field in each navaid
    let resultingNavaids : NavaidModel[] = [];
    let navaids : NavaidModel[] = arg0.get('navaids');
    let criticalNavaids : NavaidModel[] = arg0.get('criticalNavaids');
    if (navaids != undefined && criticalNavaids != undefined){
      navaids = navaids.concat(criticalNavaids).sort((a,b) => a.navaidid.localeCompare(b.navaidid));
      navaids.forEach( nav => {
        let navaidPayload = this.navaidController.getNavaidPayload(nav);
        navaidPayload.critical = nav.critical;
        resultingNavaids.push(navaidPayload);
      });
    } else {
      navaids = [];
    }


    model.navaids = resultingNavaids;

    return model;
  }


  createProcedureLegsFromProcedure( procedure : ProcedureModel, temp_id?:number) : ProcedureLegModel[]{
    let procedureLegs : ProcedureLegModel[] = [];
    let coordinatePointsSize : number = procedure.procedureCoordinatePoints.length;
    let legSequenceNumber : number = 0;

    for (let i = 0; i < coordinatePointsSize ; i++){
      if (i < coordinatePointsSize -1){
        let newLeg : ProcedureLegModel = new ProcedureLegModel();
        newLeg.procedurelegid = this.selectCoordinatePointService.getLegId();
        newLeg.startPoint = procedure.procedureCoordinatePoints[i];
        newLeg.endPoint = procedure.procedureCoordinatePoints[i+1];
        newLeg.sequencenumber = legSequenceNumber++;
        procedureLegs.push(newLeg);
        this.selectCoordinatePointService.addLegToMap(newLeg, procedure,null,temp_id? temp_id : this.currentCreateProcedureID);
      }
    }

    return procedureLegs;
  }
  closeProcedureNavaidAssociation(){
    this.procedureNavaidAssociationActive = false;
  }
/** PROCEDURE NAVAID ASSOCIATION */
  procedureNavaidAssociation(navaidFeatures: Feature[],procedureFeatures: Feature[]) : void{
    if (this.projectService.projectEditable()){
      this.procedureNavaidModel = new ProcedureNavaidAssociationModel();
      this.procedureNavaidAssociationActive = true;
      //this.menuService.toogleMenu();
      this.toolsService.navigationOnTop = true;
      this.pnaAddNavaids(navaidFeatures, true);
      this.pnaAddProcedures(procedureFeatures);
    }
  }
  pnaAddNavaids(navaidFeatures: Feature[], openWindow?: boolean) : void {
    if (!openWindow){
      let changes = false;
      navaidFeatures.forEach(el =>{
        if(this.procedureNavaidModel.navaids.find(navaid => navaid.id == el.getProperties().id) == null){
          this.procedureNavaidModel.navaids.push(this.pointsService.transformFeatureInNavaid(el));
          changes = true;
        }
      });
      if(changes){
        this.pNACreateNewTable();
      }
      return;
    }
    var changes = false;
    const proceduresIds: number[] = [];
    const allProceduresFeatures: Feature<Geometry>[] = this.pointsService.getAllProceduresFeaturesFromLayers();
    const proceduresFeatures: Feature<Geometry>[] = []
    navaidFeatures.forEach(el =>{
      if(this.procedureNavaidModel.navaids.find(navaid => navaid.id == el.getProperties().id) == null){
        const associatedProcedures: any[] = [];
        associatedProcedures.push(...el.get("associatedProcedures"));
        associatedProcedures.push(...el.get("associatedProceduresCritical"));
        if ( associatedProcedures != null && associatedProcedures.length > 0){
          for (const associatedProcedure of associatedProcedures){
            const procedureFeature: Feature<Geometry> = allProceduresFeatures.find(p => p.get("id") == associatedProcedure.id);
            if (procedureFeature != null && !proceduresIds.includes(associatedProcedure.id)){
              proceduresFeatures.push(procedureFeature);
            }
          }
        }
      }
    });
    if (proceduresFeatures.length > 0){
      this.pnaAddProcedures(proceduresFeatures);
    }
    if(changes){
      this.pNACreateNewTable();
    }
  }

  pnaAddProcedures(procedureFeatures: Feature[]) : void {
    var changes = false;
    procedureFeatures.forEach(el =>{
      if(this.procedureNavaidModel.procedures.find(procedure => procedure.procedureid == el.getProperties().procedureid) == null){
        let procedure : ProcedureModel = this.transformFeatureInProcedure(el);
        this.procedureNavaidModel.procedures.push(procedure);
        procedure.navaids.forEach(navaid => {
          if(this.procedureNavaidModel.navaids.find(nav => nav.id == navaid.id) == null){
            this.procedureNavaidModel.navaids.push(navaid);
          }
        });
        procedure.criticalNavaids.forEach(navaid => {
          if(this.procedureNavaidModel.navaids.find(nav => nav.id == navaid.id) == null){
            this.procedureNavaidModel.navaids.push(navaid);
          }
        });
        changes = true;
      }
    });
    if(changes){
      this.pNACreateNewTable();
    }
  }


  pNACreateNewTable() : void{
    this.procedureNavaidModel.rows = [];
    this.procedureNavaidModel.columns = [{ id: "-1", description: "Procedure" }];
    this.procedureNavaidModel.navaids.sort((a, b) => a.navaidid.localeCompare(b.navaidid));
    this.procedureNavaidModel.navaids.forEach(navaid => {
      this.procedureNavaidModel.columns.push(ProcedureNavaidAssociationTableColumnModel.transformNavaidInColumnModel(navaid));
    });
    this.procedureNavaidModel.procedures.forEach(procedure => {
      var row: {[k: string]: any} = {};
      row["Procedure"] = procedure.name;
      this.procedureNavaidModel.navaids.forEach((navaid) => {
        if(procedure.navaids.findIndex(el => el.id == navaid.id) > -1){
          row[navaid.id] = true;
        }
        else{
          row[navaid.id] = false;
        }
      });
      row["selected"] = false;
      this.procedureNavaidModel.rows.push(row);
    })
  }

  getInvalidNavaids(navaids: NavaidModel[]){
    return navaids.filter((navaid) => navaid.doc == null || navaid.elevation == null || navaid.maxaltitude == null)
  }
  validPerformanceFeatures( minNavaids: number, numProcedures: number): boolean {
    return (this.pointsService.getRNAVNavaids().length >= minNavaids
     && this.pointsService.getSelectedFeaturesOfType(FeatureType.Procedure).length  == numProcedures)

  }

  addCoordinatePointsFromLegs(proc : ProcedureModel){
    let coordPoints : ProcedureCoordinatePointModel[] = [];
    let i = 0;
    let coordPointSequenceNumber = 0;
    proc.procedureLegs.forEach( leg => {
      if (!(coordPoints.filter(e => e.id == leg.startPoint.id).length > 0) ) {
        //leg.startPoint.coordPoint.wtype = leg.startPoint.procedurecoordpointtype;
        leg.startPoint.coordPoint.altitude = leg.startPoint.altitude;
        if (leg.startPoint.coordPoint.published == undefined){
          leg.startPoint.coordPoint.published = true;
        }
        leg.startPoint.sequencenumber = coordPointSequenceNumber++;
        coordPoints.push(leg.startPoint);
      }
      if (!(coordPoints.filter(e => e.id == leg.endPoint.id).length > 0)) {
        //leg.endPoint.coordPoint.wtype = leg.endPoint.procedurecoordpointtype;
        leg.endPoint.coordPoint.altitude = leg.endPoint.altitude;
        if (leg.endPoint.coordPoint.published == undefined){
          leg.endPoint.coordPoint.published = true;
        }
        leg.endPoint.sequencenumber = coordPointSequenceNumber++;
        coordPoints.push(leg.endPoint);
      }
      i++;
    });

    proc.procedureCoordinatePoints = coordPoints;
    proc.actualLegId = i - 1;
  }

}
